import React, {useEffect, useState} from "react";
import {
  CButton, CCardBody,
  CCol,
  CContainer, CDataTable,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle, CPagination,
  CRow
} from "@coreui/react";

import moment from "moment"

import {useLocation} from "react-router-dom";
import Submodules from "../../../models/Submodules";
import Modules from "../../../models/Modules";
import CIcon from "@coreui/icons-react";

const SubModuleTrainingModal = (props) => {

  const learnerMode = props.learnerMode

  const [page, setPage] = useState(0);
  const [selectedSubModule, setSelectedSubModule] = useState(0)

  const [trainingData, setTrainingData] = useState([])
  let [audioScopedSlots, setAudioScopedSlots] = useState({})
  let [scoreScopedSlots, setScoreScopedSlots] = useState({})
  const [userTraining, setUserTraining] = useState(null);

  let role = "LEARNER";
  if (localStorage.getItem('role')) role = localStorage.getItem('role');
  else if (sessionStorage.getItem('role')) role = sessionStorage.getItem('role');

  const pageChange = (newPage) => {
    setPage(newPage)
  };

  useEffect(() => {
    if (props.subModule !== 0) {
      setSelectedSubModule(props.subModule)
      fetchData()
    }

    if (props.userTraining) {
      console.log("yuser training", props.userTraining)
      setUserTraining(props.userTraining)
    }

    if(props.show === false){
      setTrainingData([])
      setAudioScopedSlots({})
      setUserTraining(null)
    }

  }, [props.show, props.subModule, props.userTraining])

  const showRecording = (training, audioId, showIdx) => {
    console.log('show', training, audioId, showIdx)

    let tempScopedSlots = {}

    training.map((obj, key) => {
      let audioSpread = {}

      for (let audioIndex in obj.audio_files) {
        audioSpread["audio_" + audioIndex] = obj.audio_files[audioIndex]

        tempScopedSlots["audio_" + audioIndex] = (item) => {
          if (item.audio_files) {
            return (
              <td style={{
                padding: 0,
              }}>
                {item.id === audioId && audioIndex === showIdx ?
                  <>
                    <audio controls>
                      <source src={item.audio_files[audioIndex]} type="audio/mp3"/>
                      Your browser does not support the audio element.
                    </audio>
                    <br/>
                    <CButton
                      onClick={() => {
                        props.showMentorReview(item, props.audioLabels[audioIndex], audioIndex, item.id)
                      }}
                      color="primary"
                      variant={'outline'}
                      style={{marginTop: 5, marginBottom: 5, width: 200}}>
                      Mentor Review
                    </CButton>
                  </> :
                  <>
                    <CButton
                      color="secondary"
                      style={{marginTop: 5}}
                      onClick={() => showRecording(training, item.id, audioIndex)}>
                      Lihat Rekaman
                    </CButton>
                    <br/>
                    <CButton
                      onClick={() => {
                        props.showMentorReview(item, props.audioLabels[audioIndex], audioIndex, item.id)
                      }}
                      color="primary"
                      variant={'outline'}
                      style={{marginTop: 5, marginBottom: 5, paddingLeft: 11, paddingRight: 11}}>
                      Mentor Review
                    </CButton>
                  </>
                }
              </td>
            )
          }

          return <td>-</td>
        }
      }
    })

    setAudioScopedSlots(tempScopedSlots)
  }

  const fetchData = async () => {

    let subModuleModel = new Submodules();

    let tempTraining = await subModuleModel.getTraining(props.subModule);
    console.log('asxasxas', tempTraining);

    let tempScopedSlots = {}

    let temp = tempTraining.map((obj, key) => {
      let audioSpread = {}
      let scoreSpread = {}

      console.log("oh yeah", obj.audio_files)

      for (let audioIndex in props.audioLabels) {

        console.log("aindex " + audioIndex, obj.audio_files)


        if (obj.audio_files) audioSpread["audio_" + audioIndex] = obj.audio_files[audioIndex]

        tempScopedSlots["audio_" + audioIndex] = (item) => {
          if (item.audio_files) {
            // if (obj.audio_files && obj.audio_files[audioIndex]) {
            return <td style={{
              padding: 0,
            }}>
              <CButton
                color="secondary"
                style={{marginTop: 5}}
                onClick={() => showRecording(tempTraining, item.id)}>
                Lihat Rekaman
              </CButton>
              <br/>

              <CButton
                onClick={() => {
                  props.showMentorReview(item, props.audioLabels[audioIndex], audioIndex, item.id)
                }}
                color="primary"
                variant={'outline'}
                style={{marginTop: 5, paddingLeft: 11, paddingRight: 11, marginBottom: 5}}>
                Mentor Review
              </CButton>
            </td>
          } else {
            return <td>
              -
            </td>
          }
          // }

          // return <td>-</td>
        }
        // } else {
        //   tempScopedSlots["audio_" + audioIndex] = (item) => {
        //     return <td>
        //       -
        //     </td>
        //   }
        // }


      }

      for (let scoreIndex in props.scoreLabels) {
        scoreSpread["scores_" + scoreIndex] = obj.scores && obj.scores[scoreIndex] ? obj.scores[scoreIndex].toFixed(2) : "-"
      }

      console.log(scoreSpread)

      return {
        ...obj,
        ...audioSpread,
        ...scoreSpread
      }
    })

    console.log(temp)

    // console.log(tempScopedSlots)

    setAudioScopedSlots(tempScopedSlots)
    setTrainingData(temp)

  }


  if (!props.show) return null;

  console.log(userTraining?.user_training)

  return <>
    <CModal
      size={(userTraining && learnerMode) ? "md" : "xl"}
      centered
      show={true}
      onClose={() => {
        props.onClose()
      }}
    >
      <CModalHeader closeButton>
        <CModalTitle>{userTraining ? 'Hasil' : 'Status Pengguna'}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer>
          {/*<CRow>*/}
          {/*  <CCol>*/}
          {/*    <b>Test</b>*/}
          {/*  </CCol>*/}
          {/*</CRow>*/}
          <CRow style={{marginTop: "1em"}}>
            <CCol>
              {
                (userTraining && learnerMode) &&
                <>
                  <CRow>
                    <CCol md={userTraining ? "12" : "6"}>

                      <table>
                        <tr>
                          <td>
                            <b>Submodule&nbsp;&nbsp;&nbsp;</b>
                          </td>
                          <td>
                            : {userTraining.name}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Mentor</b>
                          </td>
                          <td>
                            : {userTraining.mentor_name}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Deskripsi</b>
                          </td>
                          <td>
                            : {userTraining.description}
                          </td>
                        </tr>
                      </table>

                      <hr/>

                      <table>
                        <tr>
                          <td>
                            <b>Waktu Pengumpulan</b>
                          </td>
                          <td>
                            : {userTraining?.user_training?.submitted_at ? new moment(userTraining.user_training.submitted_at).format("DD MMMM YYYY HH:mm") : "-"}
                          </td>
                        </tr>

                        {
                          userTraining.label_scores.map(
                            (score, idx) => {
                              return (
                                <tr>
                                  <td><b style={{marginRight: 15}}>Nilai {score}:</b></td>
                                  <td>
                                    &nbsp;: {userTraining.user_training.scores && userTraining.user_training.scores[idx] ? userTraining.user_training.scores[idx].toFixed(2) : "-"}<br/>
                                  </td>
                                </tr>
                              )
                            }
                          )
                        }
                      </table>
                      {
                        userTraining.label_audio.map(
                          (audio, idx) => {
                            return (
                              <div style={{display: 'flex', flexDirection: 'column'}}>
                                <b>{audio}:</b><br/>
                                <div style={{display: 'flex', alignItems: 'flex-end', paddingLeft: 5, width: "100%"}}>
                                  <audio controls style={{width: "100%"}}>
                                    <source src={userTraining.user_training.audio_files[idx]} type="audio/mp3"/>
                                    Your browser does not support the audio element.
                                  </audio>
                                </div>

                                <div style={{alignSelf: "flex-end", justifySelf: "flex-end"}}>
                                  <CButton
                                    onClick={() => props.showMentorReview(userTraining, audio, idx)}
                                    color="primary"
                                    variant={'outline'}
                                    style={{marginTop: 5, marginBottom: 5, width: 150}}>
                                    Mentor Review
                                  </CButton>
                                </div>
                              </div>
                            )
                          }
                        )
                      }
                      <br/>
                    </CCol>
                  </CRow>
                </>
              }

              {
                !learnerMode &&
                <>
                  <CDataTable
                    tableFilter
                    noItemsViewSlot={<div style={{
                      height: 200,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center"
                    }}>
                      <CIcon name="cil-sad" height="48" alt="Logo" style={{color: "grey"}}/>

                      <div style={{marginTop: 20}}>
                        Oops, Anda belum terdaftar menjadi mentor pada submodul ini
                      </div>
                    </div>}
                    noItemsView={() => {
                      return (
                        <td>
                          asdasd
                        </td>
                      )
                    }}
                    items={trainingData}
                    fields={[
                      {key: "user_id", _classes: "font-weight-bold", label: "id"},
                      {key: "user", _classes: "font-weight-bold", label: "Nama"},
                      {key: "submit_time", _classes: "font-weight-bold", label: "Waktu Pengumpulan"},
                      ...props.audioLabels.map((obj, key) => {
                        return {key: "audio_" + key, _classes: "font-weight-bold", label: obj}
                      }),
                      ...props.scoreLabels.map((obj, key) => {
                        return {key: "scores_" + key, _classes: "font-weight-bold", label: obj}
                      })
                      // {
                      //   key: "actions",
                      //   label: "",
                      //   // _style: {width: '1%'},
                      //   sorter: false,
                      //   filter: false,
                      // },
                    ]}
                    hover
                    striped
                    itemsPerPage={10}
                    activePage={page}
                    scopedSlots={{
                      submit_time: (item) => {

                        if (item.submitted_at) {
                          let formattedTime = new moment(item.submitted_at).format("DD MMMM YYYY HH:mm")

                          return <td>
                            {formattedTime}
                          </td>
                        } else {
                          return <td>
                            -
                          </td>
                        }

                      },
                      user: (item) => {
                        let user = item.user
                        return <td>
                          {user.full_name}
                        </td>
                      },
                      audio: (item) => {
                        return <td style={{
                          padding: 0
                        }}>
                          <audio controls>
                            <source src={item.audio_file} type="audio/mp3"/>
                            Your browser does not support the audio element.
                          </audio>
                        </td>
                      },
                      actions: (item) => (
                        <td>
                          <CButton
                            color={"info"}
                            onClick={() => {
                              console.log(item)
                            }}
                          >
                            Selengkapnya
                          </CButton>
                        </td>
                      ),
                      ...audioScopedSlots,
                      ...scoreScopedSlots
                    }}
                  />
                  <CPagination
                    activePage={page}
                    onActivePageChange={page => pageChange(page)}
                    pages={trainingData.length ? Math.ceil(trainingData.length / 10) : 1}
                    doubleArrows={false}
                    align="center"
                  />
                </>
              }
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        {/*<CButton color="primary">Do Something</CButton>{' '}*/}
        <CButton
          color="secondary"
          onClick={() => props.onClose()}
        >Cancel</CButton>
      </CModalFooter>
    </CModal>
  </>
}

export default SubModuleTrainingModal
